import React, { useMemo, useCallback } from 'react'
import { format } from 'date-fns'

import PdfGeneration from '../../../../features/components/PdfGeneration'
import { getReportPDFSections } from '../getReportPDFSections'
import { usePdfExport } from '../PdfExportContext'
import { ReactComponent as DownloadIcon } from '../../../../assets/icons/download-icon.svg'

const ExportSroiButton = () => {
  const { waitForComponents } = usePdfExport()

  const { fileName, title } = useMemo(() => {
    const currentDate = format(new Date(), 'dd-MMM-yyyy')
    const fileName = `SROI Report - ${currentDate}`
    const title = 'Social Return on Investment Report'

    return { fileName, title }
  }, [])

  const getReportPDFSectionsWithContext = useCallback(
    brandColor => getReportPDFSections(brandColor, waitForComponents),
    [waitForComponents]
  )

  return (
    <PdfGeneration
      title={title}
      getReportPDFSections={getReportPDFSectionsWithContext}
      fileName={fileName}
      buttonText="Export"
      icon={<DownloadIcon />}
    />
  )
}

export default ExportSroiButton
